<template>
    <div :class="$style['goods-detail-goods-message']">
        <pt-sub-title title="商品信息"></pt-sub-title>
        <div>
        <table class="goods-message-table">
            <tr>
                <td ref="td" :style="{width:tdMaxWidth+'px'}">商品名称：</td>
                <td>{{goodsData.name}}</td>
            </tr>
            <tr>
                <td  :style="{width:tdMaxWidth+'px'}">商品归属：</td>
                <td>{{goodsData.goods_belong}}</td>
            </tr>
            <tr>
                <td  :style="{width:tdMaxWidth+'px'}">商品类型：</td>
                <td>{{goodsData.typeName}}</td>
            </tr>
            <tr>
              <td :style="{width:tdMaxWidth+'px'}" v-if="goodsData.productCode">产品编码：</td>
              <td>{{goodsData.productCode}}</td>
            </tr>
            <template>
              <tr v-if="goodsData.goodsCompanyName">
                <td  :style="{width:tdMaxWidth+'px'}">所属公司：</td>
                <td>{{goodsData.goodsCompanyName}}</td>
            </tr>
            <tr>
              <td :style="{width:tdMaxWidth+'px'}">事业部归属：</td>
              <td>{{goodsData.businessDepartmentName}}</td>
            </tr>
            <tr>
                <td  :style="{width:tdMaxWidth+'px'}">供应商：</td>
                <td>{{vendorInfo.organizationName}}</td>
            </tr>
            <tr>
                <td  :style="{width:tdMaxWidth+'px'}">在分享中展示：</td>
                <td>{{goodsData.shareVisible?'是':"否"}}</td>
            </tr>
             <tr>
                <td  :style="{width:tdMaxWidth+'px'}">是否允许用户下单：</td>
                <td>{{goodsData.allowCustomerOrder===false?'否':"是"}}</td>
            </tr>
            <tr v-if="isExternalUrl">
                <td :style="{width:tdMaxWidth+'px'}">外链链接：</td>
                <td>{{goodsData.externalUrl}}</td>
            </tr>
            <tr v-if="!isExternalUrl">
                <td :style="{width:tdMaxWidth+'px'}">收款账户：</td>
                <td>{{vendorInfo.payment_account}}</td>
            </tr>
            </template>
            <tr v-if="isGENE&&!justShow">
                <td :style="{width:tdMaxWidth+'px'}">检测套餐：</td>
                <td>{{goodsData.genePackage_names}}</td>
            </tr>
            <tr>
                <td :style="{width:tdMaxWidth+'px'}">商品描述：</td>
                <td><div :class="$style['description-text']">{{goodsData.description}}</div></td>
            </tr>
            <tr>
                <td :style="{width:tdMaxWidth+'px'}">商品分组：</td>
                <td>{{goodsData.groupName}}</td>
            </tr>
            <tr  v-if="isGENE&&!justShow">
                <td :style="{width:tdMaxWidth+'px'}">商品周期：</td>
                <td>{{goodsData.cycle}}{{goodsData.cycle_type}}</td>
            </tr>
            <tr v-if="isShowProposer">
                <td :style="{width:tdMaxWidth+'px'}">申请人：</td>
                <td>{{proposer.name}}</td>
            </tr>
            <tr v-if="isShowApprover">
                <td :style="{width:tdMaxWidth+'px'}">审批人：</td>
                <td>{{approver.name}}</td>
            </tr>
            <tr>
                <td :style="{width:tdMaxWidth+'px'}">发布时间：</td>
                <td>{{goods_detail.putOnSaleTime}}</td>
            </tr>
        </table>
        <template  v-if="!isExternalUrl">
        <pt-sub-title title="商品价格及促销"></pt-sub-title>
        <template v-if="cashPromotionEvents&&cashPromotionEvents.length">
          <div :class="$style['description-promotion-table']">
          <description-promotion :promotion-event="cashPromotionEvents[0]" :isPromotion="isPromotion" :isExternalUrl="isExternalUrl"
                :promotionData="promotionData"  :abstractPromotionEvents="cashPromotionEvents" :tdMaxWidth="tdMaxWidth" :id="cashPromotionEvents[0].id"></description-promotion>
          </div>
        </template>
        <template v-if="otherPromotionEvents&& otherPromotionEvents.length>0">
            <div  v-for="(item,index) in otherPromotionEvents" :key="index" :class="$style['description-promotion-table']">
                <description-promotion :promotion-event="item" :isPromotion="isPromotion" :isExternalUrl="isExternalUrl"
                :promotionData="promotionData"  :abstractPromotionEvents="otherPromotionEvents" :tdMaxWidth="tdMaxWidth" :id="item.id"></description-promotion>
            </div>
        </template>
        <template v-if="(!otherPromotionEvents||!otherPromotionEvents.length)&&(!cashPromotionEvents||!cashPromotionEvents.length)">
        <description-promotion :isPromotion="isPromotion" :isExternalUrl="isExternalUrl"
                :promotionData="promotionData" :tdMaxWidth="tdMaxWidth" :specifications="specificationsItems"></description-promotion>
        </template>
        </template>
        <pt-sub-title title="支付形式"></pt-sub-title>
        <table class="goods-message-table">
          <tr>
            <td :style="{width:tdMaxWidth+'px'}">支付形式：</td>
            <td>
              {{goodsData.payment_modes}}
              <div :class="$style['specification-table-div']" class="page-background" v-if="isShow_DEPOSIT_AND_BALANCE">
                    <table  :class="$style['specification-table']">
                      <th>
                        <td></td>
                         <td>价格</td>
                          <td>订金</td>
                          <td>尾款</td>
                      </th>
                      <tr v-for="(item ,index) in specificationsItems" :key="index">
                        <td>{{item.name}}</td>
                        <td>{{item.show_detail_price}}</td>
                        <td>
                          {{item.deposit_show_detail}}
                        </td>
                        <td>{{item.balance_show}}</td>
                      </tr>
                    </table>
              </div>
            </td>
          </tr>
        </table>
          <pt-sub-title title="其他信息"></pt-sub-title>
        <table  class="goods-message-table">
            <template v-if="!isExternalUrl">
            <tr>
                <td :style="{width:tdMaxWidth+'px'}">标签：</td>
                <td>
                    <div :class="$style['specification-table-div']" class="page-background" v-if="hasLabels">
                    <table  :class="$style['specification-table']">
                        <th>
                            <td>标签</td>
                            <td>权重</td>
                        </th>
                        <tr v-for="(item,index) in goodsData.tags" :key="index">
                            <td>{{item.name}}</td>
                            <td>{{item.weight}}</td>
                        </tr>
                    </table>
                    </div>
                </td>
            </tr>
            <tr :class="$style['picture-tr']">
                <td :style="{width:tdMaxWidth+'px'}">商品图：</td>
                <td>
                    <pt-img @click.native="onPreview(goodsData.mainPicture)" v-if="goodsData.mainPicture" :class="$style['picture-radius']" :src="goodsData.mainPicture"  styleName="mall-goods-banner-pictures"></pt-img>
                </td>
            </tr>
            </template>
            <tr :class="$style['picture-tr']">
                <td :style="{width:tdMaxWidth+'px'}">广告位图片：</td>
                <td>
                    <pt-img @click.native="onPreview(goodsData.bannerPicture)"  v-if="goodsData.bannerPicture" :class="$style['picture-radius']" :src="goodsData.bannerPicture"  styleName="mall-goods-detail-banner-picture"></pt-img>
                </td>
            </tr>
            <tr v-if="!goodsData.justShow&&!isExternalUrl">
                <td :style="{width:tdMaxWidth+'px'}">商品价格：</td>
                <td>{{goodsData.final_detail_price}}</td>
            </tr>
            <tr>
                <td ref="tdInvoice">是否提供发票：</td>
                <td>{{goodsData.provideInvoice===false?'否':"是"}}</td>
            </tr>
            <tr v-if="isHasTax">
                <td :style="{width:tdMaxWidth+'px'}">税务项目：</td>
                <td>
                    <div :class="$style['specification-table-div']" class="page-background" v-if="taxProject">
                        <table :class="$style['specification-table']">
                            <th>
                                <td>项目名称</td>
                                <td>税率</td>
                                <td>单位</td>
                                <td>项目编码</td>
                            </th>
                            <tr >
                                <td>{{taxProject.xmmc}}</td>
                                <td>{{taxProject.rate}}</td>
                                <td>{{taxProject.dw}}</td>
                                <td>{{taxProject.xmbm}}</td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
            <tr>
                <td :style="{width:tdMaxWidth+'px'}">商品链接：</td>
                <td class="goods-url-td">
                    <div class="goods-url-div">
                        <template v-if="isPublished">
                            <div class="goods-url-text">{{goodsUrl}}</div>
                            <pt-copy-button :copyContent="goodsUrl" v-if="goodsDetail.goodsDTO&&goodsDetail.goodsDTO.state!=='WAITING_FOR_APPROVAL'"></pt-copy-button>
                        </template>
                        <template v-else>
                            <span class="goods-url-text">商品尚未上架，暂无商品链接</span>
                        </template>
                    </div>

                </td>
            </tr>
        </table>
        </div>
        <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
    </div>
</template>
<script>
import { isEmptyObject } from '@/utils/formUtils'
import descriptionPromotion from './description-promotion'
export default {
  props: {
    goodsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    goodsDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    justShow: {
      type: Boolean,
      default: false
    },
    specificationsItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsUrl: {
      type: String,
      default: ''
    },
    isGENE: {
      type: Boolean,
      default: false
    },
    isThirdParty: {
      type: Boolean,
      default: false
    },
    isExternalUrl: {
      type: Boolean,
      default: false
    },
    isPublished: {
      type: Boolean,
      default: true
    }
  },
  components: {
    descriptionPromotion
  },
  computed: {
    hasSpecifications () {
      return this.specificationsItems && this.specificationsItems.length > 0
    },
    hasLabels () {
      return this.goodsData && this.goodsData.tags && this.goodsData.tags.length > 0
    },
    vendorInfo () {
      return (this.goodsData && this.goodsData.vendorInfo) || {}
    },
    promotionEvent () {
      return this.goods_detail && this.goods_detail.abstractPromotionEvent
    },
    abstractPromotionEvents () {
      return (this.goods_detail && this.goods_detail.abstractPromotionEvents) || []
    },
    // 对有通用促销活动的商品促销活动数据做处理
    // 通用促销活动构成的数组
    cashPromotionEvents () {
      let res = []
      if (this.abstractPromotionEvents.length) {
        this.abstractPromotionEvents.forEach(item => {
          if (item.promotionData && item.promotionData.promotionType === 'CASH_BACK') {
            res.push(item)
          }
        })
      }
      return res
    },
    // 其他促销活动数据
    otherPromotionEvents () {
      let res = []
      if (this.abstractPromotionEvents.length) {
        this.abstractPromotionEvents.forEach(item => {
          if (item.promotionData && item.promotionData.promotionType !== 'CASH_BACK') {
            res.push(item)
          }
        })
      }
      console.log('res', res)
      return res
    },
    promotionData () {
      return (this.goodsDetail && this.goodsDetail.abstractPromotionEvent && this.goodsDetail.abstractPromotionEvent.promotionData) || {}
    },
    isPromotion () {
      return this.goodsDetail && this.goodsDetail.abstractPromotionEvent && !isEmptyObject(this.goodsDetail.abstractPromotionEvent)
    },
    // 判断促销活动是否正在进行
    isExperiment () {
      return this.promotionIsExperiment()
    },
    // 是否显示申请人
    isShowProposer () {
      return this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.state && this.goodsDetail.goodsDTO.state !== 'DRAFT'
    },
    // 申请人信息
    proposer () {
      return (this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.proposer) || {}
    },
    // 审核人信息
    approver () {
      return (this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.approver) || {}
    },
    // 是否显示审批人
    isShowApprover () {
      return this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.state && this.goodsDetail.goodsDTO.state !== 'DRAFT' && this.goodsDetail.goodsDTO.state !== 'WAITING_FOR_APPROVAL'
    },
    taxProject () {
      return this.goodsDetail.taxProjectManageDTO || null
    },
    // 是否显示税务项目
    isHasTax () {
      return this.goodsData.provideInvoice !== false
    },
    // 是否显示规格的订金+尾款表格
    isShow_DEPOSIT_AND_BALANCE () {
      return this.goodsData.paymentModes &&
      this.goodsData.paymentModes.length && this.goodsData.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1
    }
  },
  watch: {
    goodsDetail: {
      handler: function (val) {
        this.goods_detail = val
      },
      deep: true
    }
  },
  data () {
    return {
      goods_detail: this.goodsDetail || {},
      previewVisible: false,
      currentIndex: 1,
      privateImg: this.$publicResourcesUrl,
      images: '',
      specifications_items: this.specificationsItems,
      tdMaxWidth: ''
    }
  },
  methods: {
    onPreview (img) {
      this.images = this.privateImg + img
      this.previewVisible = true
    },
    closePreview () {
      this.previewVisible = false
    },
    // 判断促销活动是否正在进行
    promotionIsExperiment () {
      let promotionEvent = (this.goodsDetail && this.goodsDetail.abstractPromotionEvent) || {}
      let promotionData = promotionEvent.promotionData || {}
      let timestamp = (new Date()).getTime()
      if (promotionEvent.status === 'ACTIVATED') {
        if (timestamp > promotionData.startTime && timestamp < promotionData.endTime) {
          console.log('进行中')
          return true
        } else if (timestamp < promotionData.startTime) {
          console.log('未开始')
          return false
        } else if (timestamp > promotionData.endTime) {
          console.log('已结束')
          return false
        }
      }
    }
  },
  created () {
    setTimeout(_ => {
      let width = this.$refs.td.getBoundingClientRect().width
      let tdInvoiceWidth = this.$refs.tdInvoice.getBoundingClientRect().width
      this.$emit('tdMaxWidth', width < tdInvoiceWidth ? tdInvoiceWidth : width)
      this.tdMaxWidth = width < tdInvoiceWidth ? tdInvoiceWidth : width
    }, 300)
  }
}
</script>

<style module lang="less">
@import "~less/var";
.goods-detail-goods-message{
     :global
    .goods-message-table{
        display: block;
        width: 100%;
        tr{
            width:100%;
            display:flex;
            .goods-url-td{
                // line-height: 40px;
                color: red;
                flex: 1;
                overflow-x: hidden
            }
            td{
                line-height: 30px;
                font-size: 14px;
                .goods-url-div{
                    color: red;
                    justify-content: flex-start;
                    white-space: pre-wrap;
                    overflow-x: hidden;
                    display: flex;
                    .el-button--primary{
                        height: 40px;;
                    }
                }
                .goods-url-text{
                    color: red;
                    margin-right: 10px;
                    white-space: pre-wrap;
                    justify-content:flex-start;
                    flex:1
                }
                .el-button--primary{
                    span{
                        color: #fff
                    }
                }
            }
            :first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
                white-space: nowrap;
            }
        }
    }
}

.picture-radius{
    border-radius:5px;
    justify-content: flex-start!important;
}
.description-text{
    white-space:inherit!important;
    color: #000!important;
    justify-content: flex-start!important
}
.specification-table-div{
    margin-bottom: 20px;
    padding: 10px 20px 30px;
}
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: center;
        justify-content:flex-start!important;
        padding: 10px;
    }
}
.picture-tr{
    :global
    td{
    padding: 10px 0;
    }
    :global
    img{
        border-radius: 5px;
    }
}
.description-promotion-table{
 &+.description-promotion-table{
     border-top: #C6C9D3 solid 1px;
     padding-top: 10px;
 }
}
</style>
